// ExecutiveDetails.js
import React from 'react';
import { Box, Typography, Paper, Grid, TextField } from '@mui/material';

export default function ExecutiveDetails({ 
    formData, 
    handleInputChange, 
    RequiredLabel, 
    StandardLabel, 
    errors = {},
    t ,
    isEditMode,
    disabled = false
}) {
    return (
        <Box
            sx={{
                padding: { xs: '0px 20px', md: '0px 40px' },
                margin: { xs: '0px 20px', md: '0px 40px' },
                 backgroundColor: isEditMode ? "#E8EAEE" : "#FFFFFF",
                // border: '1px solid #A5DCF3',
                borderRadius: '10px',
                // boxShadow: '-2px 2px 5px 0px #00000040',
                // mb: 3,
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Paper
                    sx={{
                        height: 52,
                        width: '100%', 
                        borderRadius: '8px',
                        padding: '12px 24px',
                        backgroundColor: '#647490',
                        boxShadow: '-2px 2px 5px 0px #00000040',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Typography
                        variant="h6"
                        color="white"
                        sx={{ fontSize: { xs: '18px', md: '20px' } }}
                    >
                        {t('Installation Executive Details')}
                    </Typography>
                </Paper>
            </Box>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} mb={1}>
                                <StandardLabel label={t('Full Name')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('typeExecutiveName')}
                                    value={formData.executiveFullName || ''}
                                    onChange={(e) => handleInputChange(e, 'executiveFullName')}
                                    disabled={disabled}
                                    error={!!errors.executiveFullName}
                                    helperText={errors.executiveFullName}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: errors.executiveFullName ? '2px solid #d32f2f' : '2px solid #183059',
                                            '&:hover': {
                                                border: errors.executiveFullName ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: errors.executiveFullName ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }} />
                            </Grid>
                            <Grid item xs={12} sm={4} mb={1.5}>
                                <StandardLabel label={t('Phone Number')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('typeExecutivePhone')}
                                    value={formData.executivePhoneNumber || ''}
                                    onChange={(e) => handleInputChange(e, 'executivePhoneNumber')}
                                    disabled={disabled}
                                    error={!!errors.executivePhoneNumber}
                                    helperText={errors.executivePhoneNumber}
                                    inputProps={{ 
                                        pattern: '[0-9]*', 
                                        inputMode: 'numeric',
                                        maxLength: 15
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: errors.executivePhoneNumber ? '2px solid #d32f2f' : '2px solid #183059',
                                            '&:hover': {
                                                border: errors.executivePhoneNumber ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: errors.executivePhoneNumber ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }} />
                            </Grid>
                            <Grid item xs={12} sm={4} mb={1.5}>
                                <StandardLabel label={t('Email')} />
                                <TextField
                                    fullWidth
                                    type="email"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('typeExecutiveEmail')}
                                    value={formData.executiveEmail || ''}
                                    onChange={(e) => handleInputChange(e, 'executiveEmail')}
                                    disabled={disabled}
                                    error={!!errors.executiveEmail}
                                    helperText={errors.executiveEmail}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: errors.executiveEmail ? '2px solid #d32f2f' : '2px solid #183059',
                                            '&:hover': {
                                                border: errors.executiveEmail ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: errors.executiveEmail ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }} />
                            </Grid>
                        </Grid>
                      
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
